import { render } from "./ApprovalsAwaiting.vue?vue&type=template&id=b6babe48&scoped=true"
import script from "./ApprovalsAwaiting.vue?vue&type=script&lang=js"
export * from "./ApprovalsAwaiting.vue?vue&type=script&lang=js"

import "./ApprovalsAwaiting.vue?vue&type=style&index=0&id=b6babe48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6babe48"]])

export default __exports__